module.exports = __webpack_public_path__ + "img/green_040.c87f11c8.png";